module.exports = __webpack_public_path__ + "img/import-icon.6d9816cb.svg";